<div class="crash">
  <h1 class="title">{{ 'GENERIC_ERROR_MSG' | translate }}</h1>
  <div class="description">
    <div>
      {{'10129' | translate }}
      <!--Click the button below to start the program.-->
    </div>
    <br/>
    <div>
      <!--If the problem persists please contact %s-->
      {{'10130' | translate }}
    </div>
    <div class="error-info"
         *ngIf="message$ | async as message">
      {{ message }}
    </div>
  </div>
  <a [routerLink]="['/']">{{'RELOAD' | translate}}</a>
</div>
